import { render } from "./IconExpandir.vue?vue&type=template&id=215164ce&ts=true"
import script from "./IconExpandir.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconExpandir.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/IconExpandir.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "215164ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('215164ce', __exports__)) {
    api.reload('215164ce', __exports__)
  }
  
  module.hot.accept("./IconExpandir.vue?vue&type=template&id=215164ce&ts=true", () => {
    api.rerender('215164ce', render)
  })

}


export default __exports__